export enum SubbotParameterType {
  enum = 'enum', // select with hardcoded values, same for all companies (sent by BE)
  excel = 'excel',
  integer = 'integer',
  label = 'label',
  list = 'list', // list of text inputs, user can add and remove them (more than one)
  select = 'select', // simple select with dynamic values, need a call to endpoint to get values
  string = 'string',
}
